import { ActionIcon, Tooltip } from '@mantine/core';
import { IconMapPin } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useLocationTracking } from './useLocationTracking';

/** Transparenz-Hinweis „Standort wird erfasst“ (ACT-04). */
export function LocationIndicator() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { active, error } = useLocationTracking();
  if (!active) return null;
  return (
    <Tooltip label={error ? t('activity.trackingError', { error }) : t('activity.trackingActive')}>
      <ActionIcon variant="light" color={error ? 'red' : 'orange'} size="lg" aria-label={t('activity.trackingActive')} onClick={() => navigate('/profile')}>
        <IconMapPin size={20} />
      </ActionIcon>
    </Tooltip>
  );
}
